import { type DocumentReference } from 'firebase/firestore';

import { hostingStoragePathToUrl } from 'services/Firebase';
import { getAppBroker } from 'stores/AppBroker';
import { computeCreativeStorageScope } from 'stores/CreativeUtils';
import * as DatabasePaths from 'stores/DatabasePaths';
import { DocumentCollectionType } from 'types/DocumentCollectionType';
import { DocumentType } from 'types/DocumentType';
import { slashJoin } from 'utils/String';

import { getAdHubClientConfig } from '../config';
import { AnimationPublicSchema } from './Animation';
import AnimationPlayer from './AnimationPlayer';
import BreadcrumbManager from './BreadcrumbManager';
import DocumentStore from './DocumentStore';

export default class AnimationPreview extends DocumentStore<AnimationPublicSchema> {
    schema = new AnimationPublicSchema();
    breadcrumbs: BreadcrumbManager = new BreadcrumbManager(this);
    type = DocumentType.ASSET;
    collectionType = DocumentCollectionType.ASSET;

    filename = '';
    previewURL = '';
    parentDocRef: DocumentReference;
    player = new AnimationPlayer();

    constructor(
        parent: unknown,
        docRef: DocumentReference,
        parentDocRef: DocumentReference
    ) {
        super(parent, docRef);
        this.parentDocRef = parentDocRef;
        this.becomeObservable();
    }

    onLoad = async (_data: AnimationPublicSchema) => {
        await this.breadcrumbs.load(this.parentDocRef.path, { crumbCount: 2 });
    };

    setPreviewURL = (assetFilename: string) => {
        this.previewURL = this.getAssetURL(assetFilename);
    }

    navigateToParent = () => {
        const coord = DatabasePaths.creative.requireMatch(
            this.parentDocRef.path
        );
        void getAppBroker().navigate(coord);
    }

    getAssetURL = (filename: string) => {
        // somewhat duplicated in stores/Assets.ts
        const config = getAdHubClientConfig();
        const creativeScope = computeCreativeStorageScope(
            this.parentDocRef.path
        );
        const pathname = slashJoin(
            config.assetsStoragePath,
            creativeScope,
            filename
        );
        return hostingStoragePathToUrl(pathname);
    }
}
